import { getWindowObject } from './get-window-object';

export const getPerformanceObject = (): Performance | undefined => {
	const { performance } = getWindowObject() || {};

	return performance;
};
